import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const EventCard = props => {
    const evt = props.event;
    const org = props.organizationName;
    const late = props.isLate || false;
    const eventDate = moment(evt.date).format('YYYY-MM-DD');
    const eventFromNow = moment(evt.date).fromNow();

    let practices = '';
    if (evt.practices && evt.practices.length > 0) {
        let names = [];
        evt.practices.forEach(practice => {
            names.push(practice.name);
        });
        practices = names.join(', ');
    }

    return (
        <div className="EventCard">
            <div
                className={`EventCard__header
                    ${late ? 'EventCard__header-late' : ''}
                `}>
                <span className="EventCard__header-left">{eventDate}</span>
                <span className="EventCard__header-right">{eventFromNow}</span>
            </div>
            {late && evt.organization_id && (
                <div className="EventCard__footer-late">
                    <Link
                        className="Navbar__link Late__link"
                        to={
                            '/organization/' +
                            evt.organization_id +
                            '/schedule/' +
                            evt.id +
                            '/edit'
                        }>
                        This deadline is not marked as complete. Click here to
                        edit.
                    </Link>
                </div>
            )}
            <div className="EventCard__body">
                <h3>Check-in #{evt.checkin}</h3>
                <h4>{evt.name}</h4>
                <h5>{org}</h5>
                <p>{practices}</p>
            </div>
        </div>
    );
};

export default EventCard;
